export enum RequestDocumentStatusLabel {
    DISCARDED = 'DISCARDED',
    REQUEST_RESUBMISSION = 'REQUEST_RESUBMISSION',
    RESUBMITTED = 'RESUBMITTED',
    APPROVED = 'APPROVED'
}

export const ALL_REQUEST_DOCUMENT_STATUS = ['DISCARDED', 'REQUEST_RESUBMISSION', 'RESUBMITTED', 'APPROVED'];
